import { Sheet, SheetContent } from '@/components/ui/sheet';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface CreateTermineSheetWrapperProps {
  onClose: () => void;
  children: ReactNode;
}

export function CreateTermineSheetWrapper({
  onClose,
  children,
}: CreateTermineSheetWrapperProps) {
  const { t } = useTranslation();

  return (
    <Sheet open onOpenChange={onClose}>
      <SheetContent
        className="p-0 min-w-max min-h-min sm:max-w-114.5"
        removeCloseIcon>
        <Suspense
          fallback={
            <div className="flex flex-col h-screen gap-4 items-center justify-center text-sm">
              <FontAwesomeIcon
                icon={faSpinnerThird}
                className="text-primary-blue-200"
                spin
                size="4x"
              />
              {t('actions.loading')}
            </div>
          }>
          {children}
        </Suspense>
      </SheetContent>
    </Sheet>
  );
}
